import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Pressable,
  ScrollView,
  ImageBackground,
  FlatList,
  Animated
} from "react-native";

import * as Animatable from "react-native-animatable";
import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as ServerOperations from "../utils/ServerOperations";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let brandPos = 1;
let brandFlag = 1;
const img1 = require("../images/home/img1.png");
const img2 = require("../images/home/img2.png");
const img3 = require("../images/home/img3.png");
const img4 = require("../images/home/img4.png");
const arrowRight = require("../images/arrowright.png");
const arrowRight2 = require("../images/arrowright2.png");
const jo1 = require("../images/home/jo1.png");
const jo2 = require("../images/home/jo2.png");
const jo3 = require("../images/home/jo3.png");
const jo4 = require("../images/home/jo4.png");
const jo5 = require("../images/home/jo5.png");
const joImgs = [jo1, jo2, jo3, jo4, jo5]
const videothumb = require("../images/home/videothumb.jpg");
const playBlue = require("../images/home/playWhite.png");
const playWhite = require("../images/home/playWhite.png");
let isMobile = false;
// const videothumb2 = require("../images/home/videothumb2.png");

const VIDEO_SRC = "https://sales.jdsco.net:8444/pick/faces/attachments/jds/jds.webm";
const VIDEO_SRC_MOBILE = "https://sales.jdsco.net:8444/pick/faces/attachments/jds/jds.webm";

// Memoized so the <video> DOM node survives Home's re-renders; building it through
// dangerouslySetInnerHTML made React rebuild the element and restart playback.
const VideoPlayer = React.memo(function VideoPlayer({ src, height }) {
  return (
    <video height={height} width="100%" controls autoPlay>
      <source src={src} type="video/webm" />
      Your browser does not support the video tag.
    </video>
  );
});
class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      isVideoPlaying: false,
      brands: [],
      joImgPos: 0,
      hideScrollTopButton: true
    };
  }
  Pressables = {};


  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.joImgInterval);
  }

  async componentDidMount() {
    const brandsResp = await ServerOperations.getBrands();
    const brands = [];
    brandsResp.map(async brand => {
      Image.getSize(brand.IMG, (width, height) => {
        const widthx = isMobile ? width / height > 3 ? 100 : 40 * width / height : width / height > 3 ? 200 : 60 * width / height;
        brands.push(<Image source={brand.IMG} style={{ height: isMobile ? 40 : 60, width: widthx }} resizeMode="contain" />);
      });
    }
    );

    setTimeout(() => {
      // Repeat the logos a fixed number of times so the marquee has runway;
      // `push(...brands)` in a loop grew the list 2^10 times and blew up the render.
      const loopedBrands = [];
      for (let i = 0; i < 10; i++) {
        loopedBrands.push(...brands);
      }
      this.setState({ brands: loopedBrands });
      this.scrollX = new Animated.Value(0);
      this.brandPos = 0;
      this.brandFlag = 1; // Adjust as needed 
      this.brandsView = React.createRef();

      this.interval = setInterval(() => { this.scrollBrand(); }, 45);
      this.joImgInterval = setInterval(() => {
        let joImgPos = this.state.joImgPos + 1;
        if (joImgPos >= joImgs.length) joImgPos = 0;
        this.setState({ joImgPos });
      }, 1500);
    }, 500);

  }
  scrollBrand = () => {
    this.brandPos += this.brandFlag;
    const x = this.brandPos * 4;
    if (this.brandsView.current) {
      Animated.timing(this.scrollX, {
        toValue: x,
        duration: 45, // Adjust the duration for smooth scrolling 
        useNativeDriver: true,
      }).start(() => {
        this.brandsView.current.scrollToOffset({ offset: x, animated: false });
      });
    }
  }

  renderPressableButton = (componentRef, text, onPress) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={isHovered ? Styles.ButtonStyleHovered : Styles.ButtonStyle}>
          <Text style={isHovered ? Styles.ButtonTextStyleHovered : Styles.ButtonTextStyle}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderPressableLink = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle, {
            fontSize: 15
          }]}>{text}</Text>
          <Image source={isHovered ? arrowRight2 : arrowRight} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderMobile = () => {
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          <View style={{ width, paddingHorizontal: 20, gap: 50, textAlign: 'center' }}>
            {Styles.renderVSeparator(100)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {this.renderPart3Mobile()}
            {this.renderPart4Mobile()}
            {this.renderPart5Mobile()}
            {this.renderPart6Mobile()}
          </View>
          {Commons.renderFooter({}, this)}
        </ScrollView >
      </View>

    );
  }

  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    width = Commons.getWidth();
    styles = this.styles();
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          {this.renderPart1()}
          {this.renderPart2()}
          {this.renderPart3()}
          {this.renderPart4()}
          {this.renderPart5()}
          {this.renderPart6()}
          {Commons.renderFooter({}, this)}
        </ScrollView >
      </View >
    );
  }

  renderPart1 = () => {
    return (<ImageBackground style={styles.image} source={img1}>
      <View style={{
        alignItems: "flex-start",
        gap: 30,
        marginLeft: 164,
        marginTop
      }}>
        <Text style={[Styles.TextStyle1, { letterSpacing: -0.5 }]}>Striving for better{`\n`}health and wellbeing </Text>
        <Text style={[Styles.TextStyle2]}>Efficiently connecting pharmaceutical and parapharmaceutical {`\n`}suppliers with healthcare providers in Jordan. </Text>
        {this.renderPressableButton('getInTouchButton', 'Get In Touch', () => window.location = './contactus')}
      </View>
    </ImageBackground>)
  }

  renderPart1Mobile = () => {
    return (<View style={{ gap: 30 }}>
      <Text style={[Styles.TextStyle1, { letterSpacing: -0.5, textAlign: 'left' }]}>Striving for better{`\n`}health and wellbeing </Text>
      <Text style={[Styles.TextStyle2, { textAlign: 'left' }]}>Connecting pharmaceutical and parapharmaceutical {`\n`}suppliers with healthcare providers in Jordan. </Text>
      <Image source={img1} style={{ height: .5 * width - 40, width: '100%' }} resizeMode="cover" />
      {this.renderPressableButton('getInTouchButton', 'Get In Touch', () => window.location = './contactus')}
    </View>)
  }

  renderPart2 = () => {
    const brands = this.state.brands;
    return (
      <View style={{
        alignItems: "center",
        gap: 20,
        marginTop: marginTop - 50
      }}>
        <Text style={[Styles.TextStyle1, { fontSize: 22, fontWeight: '700', fontStyle: 'normal' }]}>
          Trusted by leading brands <Text style={{ fontWeight: '400' }}>worldwide</Text>
        </Text>

        <FlatList
          ref={this.brandsView}
          contentContainerStyle={{
            height: 126,
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 82.044,
          }}
          style={{ width: width }}
          data={brands}
          renderItem={this.renderBrandItem}
          keyExtractor={(item, index) => index}
          keyboardShouldPersistTaps={"always"}
          removeClippedSubviews
          showsHorizontalScrollIndicator={false}
          initialNumToRender={100}
          scrollEventThrottle={100}
          onScroll={this.onBrandScroll}
          scrollEnabled={true}
          horizontal={true}
        />
      </View>
    )
  }


  renderPart2Mobile = () => {
    const brands = this.state.brands;
    return (
      <View style={{
        alignItems: "center",
        gap: 20,
        marginVertical: 50
      }}>
        <Text style={[Styles.TextStyle1, { fontSize: 22, fontWeight: '700', fontStyle: 'normal' }]}>
          Trusted by leading brands <Text style={{ fontWeight: '400' }}>worldwide</Text>
        </Text>
        <FlatList
          ref={this.brandsView}
          contentContainerStyle={{
            height: 126,
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 82.044,
          }}
          style={{ width: width }}
          data={brands}
          renderItem={this.renderBrandItem}
          keyExtractor={(item, index) => index}
          keyboardShouldPersistTaps={"always"}
          removeClippedSubviews
          showsHorizontalScrollIndicator={false}
          initialNumToRender={100}
          scrollEventThrottle={100}
          onScroll={this.onBrandScroll}
          scrollEnabled={true}
          horizontal={true}
        />
      </View>
    )
  }

  renderBrandItem = ({ item }) => {
    // return <Text>{index}</Text>
    return (item);
  }

  renderPart3 = () => {
    const componentRef = 'video';
    return (
      <View style={{ width, paddingHorizontal: 164, marginTop: 60 }}>
        <Pressable
          ref={el => (this.Pressables[componentRef] = el)}
          onHoverIn={() => {
            this.setState({ hoveredComponent: this.Pressables[componentRef] });
            if (!this.isVideoPlaying) {
              try {
                // this.videothumb.animate({ 0: { opacity: 1.0 }, 1: { opacity: 1 } }, 500);
                // this.playBlue.animate({ 0: { opacity: 1 }, 1: { opacity: 0 } }, 500);
                // this.playWhite.animate({ 0: { opacity: 0 }, 1: { opacity: 1 } }, 500);
              } catch (err) { }
            }
          }}
          onHoverOut={() => {
            this.setState({ hoveredComponent: undefined });
            if (!this.isVideoPlaying) {
              try {
                // this.videothumb.animate({ 1: { opacity: 1.0 }, 0: { opacity: 1 } }, 500);
                // this.playBlue.animate({ 1: { opacity: 1 }, 0: { opacity: 0 } }, 500);
                // this.playWhite.animate({ 1: { opacity: 0 }, 0: { opacity: 1 } }, 500);
              } catch (err) { }
            }
          }} >
          <TouchableOpacity onPress={() => {
            this.setState({ isVideoPlaying: true });
          }}
          >

            {!this.state.isVideoPlaying &&
              // <Image source={videothumb} style={{ width: '100%', height: width * 0.87 * 0.45 }} resizeMode="cover" />
              <View style={{ alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                <Animatable.Image
                  ref={el => (this.videothumb = el)}
                  source={videothumb} style={{ width: '100%', height: width * 0.87 * 0.45, opacity: 1.0 }} resizeMode="cover" >
                </Animatable.Image>
                <Animatable.Image
                  ref={el => (this.playWhite = el)}
                  source={playWhite} style={{ width: 41, height: 41, color: Styles.appColor1, opacity: 0, position: "absolute", top: width * 0.87 * 0.45 * 0.5 - 25 }} resizeMode="contain" >
                </Animatable.Image>
                <Animatable.Image
                  ref={el => (this.playBlue = el)}
                  source={playBlue} style={{ width: 41, height: 41, color: Styles.appColor1, opacity: 1, position: "absolute", top: width * 0.87 * 0.45 * 0.5 - 25 }} resizeMode="contain" >
                </Animatable.Image>
              </View>


            }
            {/* {!this.state.isVideoPlaying && isHovered &&

              <Animatable.View
                animation="fadeIn"
                easing="ease-in"
                duration={250}
              >
                
              </Animatable.View>
            } */}
            {this.state.isVideoPlaying &&
              <VideoPlayer src={VIDEO_SRC} height={width * 0.87 * 0.5} />
              // <Video
              //   ref={el => (this.video = el)}
              //   style={{ videoBackgroundColor: WHITE, height: width * 0.87 * 0.45 }}
              //   source={{
              //     uri: 'https://puresoft.ddns.net/pick/faces/attachments/jds.webm',
              //   }}
              //   useNativeControls
              //   resizeMode={ResizeMode.COVER}
              //   shouldPlay={true}
              //   onPlaybackStatusUpdate={status => this.setState({ status })}
              // />
            }

          </TouchableOpacity>
        </Pressable>
      </View >
    )
  }


  renderPart3Mobile = () => {
    const componentRef = 'video';
    return (
      <View style={{}}>
        <Pressable
          ref={el => (this.Pressables[componentRef] = el)}>
          <TouchableOpacity onPress={() => {
            this.setState({ isVideoPlaying: true });
          }}
          >
            {!this.state.isVideoPlaying &&
              <View style={{ alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                <Animatable.Image
                  ref={el => (this.videothumb = el)}
                  source={videothumb} style={{ width: '100%', height: width * 0.87 * 0.45, opacity: 1.0 }} resizeMode="cover" >
                </Animatable.Image>
                <Animatable.Image
                  ref={el => (this.playWhite = el)}
                  source={playWhite} style={{ width: 41, height: 41, color: Styles.appColor1, opacity: 0, position: "absolute", top: width * 0.87 * 0.45 * 0.5 - 25 }} resizeMode="contain" >
                </Animatable.Image>
                <Animatable.Image
                  ref={el => (this.playBlue = el)}
                  source={playBlue} style={{ width: 41, height: 41, color: Styles.appColor1, opacity: 1, position: "absolute", top: width * 0.87 * 0.45 * 0.5 - 25 }} resizeMode="contain" >
                </Animatable.Image>
              </View>
            }
            {this.state.isVideoPlaying &&
              <VideoPlayer src={VIDEO_SRC_MOBILE} height={width * 0.8 * 0.65} />
            }
          </TouchableOpacity>
        </Pressable>
      </View >
    )
  }

  renderPart4 = () => {
    return (<View style={{ paddingTop: 60 }} >
      {Styles.renderVSeparator(35)}
      <View style={{
        paddingHorizontal: 0.11 * width,
        background: 'linear-gradient(0deg, rgba(82, 192, 238, 0.23) 0%, rgba(82, 192, 238, 0.23) 100%), #FFF',
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
      }}>
        <Image source={joImgs[this.state.joImgPos]} style={{ height: 380, width: 348 }} resizeMode="contain" />
        <View style={{ flexGrow: 1 }} />
        <View style={{
          gap: 30,
          justifyContent: "space-between",
        }}>
          <Text style={[Styles.TextStyle1, { letterSpacing: 0.28, fontSize: 28 }]}>A Comprehensive {`\n`}Distribution Solution </Text>
          <Text style={[Styles.TextStyle2]}>Storage, distribution & marketing services for both suppliers and
            {`\n`}healthcare providers. By partnering with us, you gain access to a full suite of
            {`\n`}services designed to enhance efficiency, compliance, and market reach.</Text>
          {/* {this.renderPressableLink('Learn more', { letterSpacing: 1.25 }, () => this.props.navigation.navigate("service", { v: new Date().getSeconds() }))} */}
          {this.renderPressableLink('Learn more', { letterSpacing: 1.25 }, () => window.location = './service')}
        </View>
      </View>
    </View>)
  }

  renderPart4Mobile = () => {
    return (
      <View style={{
        background: 'linear-gradient(0deg, rgba(82, 192, 238, 0.23) 0%, rgba(82, 192, 238, 0.23) 100%), #FFF',
        alignItems: "center",
        height: 518,
        paddingVertical: 50,
        gap: 18,
        justifyContent: "center"
      }}>
        <Text style={[Styles.TextStyle1, { letterSpacing: 0.28, fontSize: 28, paddingHorizontal: 20 }]}>A Comprehensive {`\n`}Distribution Solution </Text>
        <Text style={[Styles.TextStyle2, { paddingHorizontal: 20, letterSpacing: 0.8 }]}>Storage, distribution & marketing services for both suppliers and
          healthcare providers. By partnering with us, you gain access to a full suite of
          services designed to enhance efficiency, compliance, and market reach.</Text>
        {this.renderPressableLink('Learn more', { letterSpacing: 1.25 }, () => window.location = './service')}
      </View>
    )
  }


  renderPart5 = () => {
    const isHovered1 = this.state.hoveredComponent && this.Pressables['pharmadiv'] == this.state.hoveredComponent;
    const isHovered2 = this.state.hoveredComponent && this.Pressables['parapharmadiv'] == this.state.hoveredComponent;
    try {
      if (isHovered1 && !this.isHovered1) {
        // this.pharmadiv.animate({ 0: { filter: 'brightness(100%)' }, 1: { filter: 'brightness(110%)' } });
        // this.pharmadivText1.animate({ 0: { color: Styles.appColor1 }, 1: { color: '#52c0ee' } });
        // this.pharmadivText2.animate({ 0: { color: Styles.appColor1 }, 1: { color: '#52c0ee' } });
      } else if (!isHovered1 && this.isHovered1) {
        // this.pharmadiv.animate({ 1: { filter: 'brightness(100%)' }, 0: { filter: 'brightness(110%)' } });
        // this.pharmadivText1.animate({ 1: { color: Styles.appColor1 }, 0: { color: '#52c0ee' } });
        // this.pharmadivText2.animate({ 1: { color: Styles.appColor1 }, 0: { color: '#52c0ee' } });
      }

      if (isHovered2 && !this.isHovered2) {
        // this.parapharmadiv.animate({ 0: { filter: 'brightness(100%)' }, 1: { filter: 'brightness(115%)' } });
        // this.parapharmadivText1.animate({ 0: { color: Styles.appColor1 }, 1: { color: '#52c0ee' } });
        // this.parapharmadivText2.animate({ 0: { color: Styles.appColor1 }, 1: { color: '#52c0ee' } });
      } else if (!isHovered2 && this.isHovered2) {
        // this.parapharmadiv.animate({ 1: { filter: 'brightness(100%)' }, 0: { filter: 'brightness(115%)' } });
        // this.parapharmadivText1.animate({ 1: { color: Styles.appColor1 }, 0: { color: '#52c0ee' } });
        // this.parapharmadivText2.animate({ 1: { color: Styles.appColor1 }, 0: { color: '#52c0ee' } });
      }
    } catch (err) { }
    this.isHovered1 = isHovered1
    this.isHovered2 = isHovered2
    return (<View style={{ paddingTop: 60 }} >
      {Styles.renderVSeparator(35)}
      <View style={{
        paddingHorizontal: 0.11 * width,
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
      }}>

        <Pressable
          style={{ cursor: 'normal' }}
          ref={el => (this.Pressables['pharmadiv'] = el)}
          onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['pharmadiv'] })}
          onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
          <Animatable.View ref={el => (this.pharmadiv = el)} style={[{ gap: 20 }]}>
            <Animatable.Text ref={el => (this.pharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 22 }]}>Pharmaceutical Division</Animatable.Text>
            <Image source={img2} style={{ height: 308, width: 426 }} resizeMode="cover" />
            <Animatable.Text ref={el => (this.pharmadivText2 = el)} style={[Styles.TextStyle2]}>Our pharmaceutical segment includes a range of
              {`\n`}pharmaceutical products & medical devices to support
              {`\n`}healthcare professionals, pharmacies and institutions.</Animatable.Text>
          </Animatable.View>
        </Pressable>
        <Pressable
          style={{ cursor: 'normal' }}
          ref={el => (this.Pressables['parapharmadiv'] = el)}
          onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['parapharmadiv'] })}
          onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
          <View style={{ flexGrow: 1 }} />
          <Animatable.View ref={el => (this.parapharmadiv = el)} style={[{ gap: 20 }]}>
            <Animatable.Text ref={el => (this.parapharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 22 }]}>Parapharmaceutical Division</Animatable.Text>
            <Image source={img3} style={{ height: 308, width: 426 }} resizeMode="cover" />
            <Animatable.Text ref={el => (this.parapharmadivText2 = el)} style={[Styles.TextStyle2]}>The parapharmaceutical segment includes consumer
              {`\n`}healthcare products, including over-the-counter (OTC)
              {`\n`}medications and personal care items.</Animatable.Text>
          </Animatable.View>
        </Pressable>
      </View>
    </View>)
  }

  renderPart5Mobile = () => {
    return (<View style={{ gap: 50, alignItems: "center", textAlign: 'left' }} >
      <Pressable
        style={{ cursor: 'normal' }}
        ref={el => (this.Pressables['pharmadiv'] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['pharmadiv'] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <Animatable.View ref={el => (this.pharmadiv = el)} style={[{ gap: 20 }]}>
          <Animatable.Text ref={el => (this.pharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 22 }]}>Pharmaceutical Division</Animatable.Text>
          <Image source={img2} style={{ height: .5 * width - 40, width: width - 40 }} resizeMode="cover" />
          <Animatable.Text ref={el => (this.pharmadivText2 = el)} style={[Styles.TextStyle2]}>Our pharmaceutical segment includes a range of
            pharmaceutical products & medical devices to support
            healthcare professionals, pharmacies and institutions.</Animatable.Text>
        </Animatable.View>
      </Pressable>
      <Pressable
        style={{ cursor: 'normal' }}
        ref={el => (this.Pressables['parapharmadiv'] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['parapharmadiv'] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <View style={{ flexGrow: 1 }} />
        <Animatable.View ref={el => (this.parapharmadiv = el)} style={[{ gap: 20 }]}>
          <Animatable.Text ref={el => (this.parapharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 22 }]}>Parapharmaceutical Division</Animatable.Text>
          <Image source={img3} style={{ height: .5 * width - 40, width: width - 40 }} resizeMode="cover" />
          <Animatable.Text ref={el => (this.parapharmadivText2 = el)} style={[Styles.TextStyle2]}>The parapharmaceutical segment includes consumer
            healthcare products, including over-the-counter (OTC)
            medications and personal care items.</Animatable.Text>
        </Animatable.View>
      </Pressable>
    </View>)
  }

  renderPart6 = () => {
    return (<View style={{ paddingTop: 60 }} >
      {Styles.renderVSeparator(35)}
      <View style={{
        paddingLeft: 0.114 * width,
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        background: 'rgba(107, 164, 97, 0.11)'
      }}>
        <View style={{ gap: 30 }}>
          <Text style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 28 }]}>Explore Exciting Career Opportunities</Text>
          <Text style={[Styles.TextStyle2, { fontSize: 16 }]}>The heart of our success lies in our dedicated team members. With
            {`\n`}diverse roles available across our organization, we offer valuable
            {`\n`}opportunities for individuals to contribute their unique skills and
            {`\n`}talents,  fostering a collaborative and thriving work environments.</Text>
          {/* {this.renderPressableLink('Careers', { letterSpacing: 1.25 }, () => this.props.navigation.navigate("careers", { v: new Date().getSeconds() }))} */}
          {this.renderPressableLink('Careers', { letterSpacing: 1.25 }, () => window.location = './careers')}
        </View>
        <View style={{ flexGrow: 1 }} />
        <Image source={img4} style={{ height: 380, width: 591 }} resizeMode="cover" />
      </View>
    </View>)
  }

  renderPart6Mobile = () => {
    return (<View style={{
      alignItems: "center",
      paddingVertical: 50,
      paddingHorizontal: 20,
      gap: 18,
      justifyContent: "center",
      background: 'rgba(107, 164, 97, 0.11)'
    }} >
      <Text style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 28 }]}>Explore Exciting{`\n`}Career Opportunities</Text>
      <Image source={img4} style={{ height: .6 * width - 40, width: width - 80 }} resizeMode="cover" />
      <Text style={[Styles.TextStyle2, {}]}>The heart of our success lies in our dedicated team members. With
        diverse roles available across our organization, we offer valuable
        opportunities for individuals to contribute their unique skills and
        talents,  fostering a collaborative and thriving work environments.</Text>
      {/* {this.renderPressableLink('Careers', { letterSpacing: 1.25 }, () => this.props.navigation.navigate("careers", { v: new Date().getSeconds() }))} */}
      {this.renderPressableLink('Careers', { letterSpacing: 1.25 }, () => window.location = './careers')}
    </View>)
  }

  onBrandScroll = (e) => {
    try {
      const endReached =
        parseInt(e.nativeEvent.contentOffset.x) +
        parseInt(e.nativeEvent.layoutMeasurement.width) -
        parseInt(e.nativeEvent.contentSize.width) ==
        0;
      const startReached = e.nativeEvent.contentOffset.x == 0;
      if (endReached) {
        this.brandPos = 0;
        if (this.brandsView.current) this.brandsView.current.scrollToOffset({ animated: false, offset: 0 });
      } else if (startReached) {
        this.brandFlag = 1;
      }
    } catch (err) { }
  };

  styles = () => ({
    container: {
      flex: 1,
      width: width,
      paddingVertical: 0,
      paddingHorizontal: 164,
      alignItems: "center",
      gap: 100,
      backgroundColor: WHITE
    },
    image: {
      flex: 1,
      resizeMode: 'contain',
      justifyContent: 'center',
      width,
      height: 590,
    }
  });
}



export default Home;
